import { defineStore } from "pinia";
import Network from "~/utils/network";

const urls = {
  onboarding: (countryId, type) => `/api/administration/onboarding/${countryId}?type=${type}`,
};

export const useOnboardingStore = defineStore("onboarding", {
  state: () => ({
    steps: [],
  }),
  actions: {
    load: async function (countryId, type = "BNPL") {
      try {
        this.steps = await Network.http(urls.onboarding(countryId, type));
      } catch (err) {
        console.log(err);
        await Promise.reject(err);
      }
    },
  },
});
